// material-ui
import { createTheme } from '@mui/material/styles';

// project import
import ThemeOption from './theme';

// ==============================|| DEFAULT THEME - PALETTE - MODERN ||============================== //

export default function Palette(mode) {
  const paletteColor = ThemeOption();
  const isDark = mode === 'dark';

  return createTheme({
    palette: {
      mode,
      common: {
        black: '#000000',
        white: '#FFFFFF'
      },
      ...paletteColor,
      text: {
        primary: isDark ? '#F3F6F8' : paletteColor.grey[900],
        secondary: isDark ? '#B8C1C9' : paletteColor.grey[700],
        disabled: isDark ? '#6F7A84' : paletteColor.grey[500]
      },
      action: {
        selected: isDark ? 'rgba(244, 246, 248, 0.12)' : 'rgba(44, 62, 80, 0.08)',
        disabled: isDark ? 'rgba(244, 246, 248, 0.26)' : paletteColor.grey[300],
        hover: isDark ? 'rgba(244, 246, 248, 0.06)' : 'rgba(44, 62, 80, 0.04)'
      },
      divider: isDark ? 'rgba(244, 246, 248, 0.12)' : paletteColor.grey[200],
      background: {
        paper: isDark ? '#141B23' : paletteColor.grey[0],
        default: isDark ? '#0D1117' : paletteColor.grey[50]
      }
    }
  });
}
